import { defineMessages } from 'react-intl'

export const jobInfoMessages = defineMessages({
  jobDetailsTitle: {
    id: 'jobInfo.jobDetailsTitle',
    description: 'Job details block title on JobInfo page',
    defaultMessage: 'Job Details',
  },
  addHomeTitle: {
    id: 'jobInfo.addHomeTitle',
    description: 'Title of the Add Home block on Job page',
    defaultMessage: 'Home',
  },
  addHomeBtn: {
    id: 'jobInfo.addHomeBtn',
    description: 'Title of the Add Home button on Job page',
    defaultMessage: 'Add Home',
  },
  addHomeMsg: {
    id: 'jobInfo.addHomeMsg',
    description: 'Message on the Job page calling to Add Home',
    defaultMessage:
      'Add home by claiming it by code. Or you may add home to this job through the Savant Studio iPad app, or through System Monitor starting with SavantOS 8.9.',
  },
  jobFilesTableTitle: {
    id: 'jobInfo.jobFilesTableTitle',
    description: 'Job files table title on JobInfo page',
    defaultMessage: 'Job Files',
  },
})
